export default __webpack_public_path__ + "static/media/sentencing-2.d0441210.jpg";